<template>
  <b-modal :id="id" @hidden="$emit('hidden')" @hide="$emit('hide')"
          header-class="base-modal-header"
          dialog-class="base-modal-dialog"
          modal-class="base-modal"
          body-class="base-modal-body"
          content-class="base-modal-content"
          scrollable
          :hide-footer="true"
          :no-close-on-backdrop="!closeVisible"
          :hide-header="!closeVisible">
    <template v-slot:default>
      <slot></slot>
    </template>
    <template v-if="closeVisible" v-slot:modal-header-close>
      <font-awesome-icon :icon="['fal', 'times-circle']"></font-awesome-icon>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'BaseModal',
  props: {
    id: String,
    closeVisible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">
</style>
